import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../../material.module';
import { SharedModule } from '../../shared/shared.module';
import { DailyForecastComponent } from './components/daily-forecast/daily-forecast.component';
import { HourlyForecastComponent } from './components/hourly-forecast/hourly-forecast.component';
import { MeteogramComponent } from './components/meteogram/meteogram.component';
import { NextHourForecastComponent } from './components/next-hour-forecast/next-hour-forecast.component';
import { WeatherRoutingModule } from './weather-routing.module';

@NgModule({
  declarations: [DailyForecastComponent, HourlyForecastComponent, MeteogramComponent, NextHourForecastComponent],
  imports: [CommonModule, MaterialModule, SharedModule, WeatherRoutingModule],
  exports: [MeteogramComponent, NextHourForecastComponent],
})
export class WeatherModule {}
